import {ValidationError} from '../../models/validation-error.model';
import {PasswordPolicy} from '../../models/password-policy.model';
import {SearchQueryParams} from '../../models/search-query-params.model';

export namespace PasswordPolicyActions {
    export class GetById {
        static readonly type = 'PasswordPolicyActions.GetById';

        constructor(public policyId: number) {}
    }

    export class GetListPage {
        static readonly type = 'PasswordPolicyActions.GetListPage';

        constructor(public params?: SearchQueryParams) {}
    }

    export class Add {
        static readonly type = 'PasswordPolicyActions.Add';

        constructor(public readonly passwordPolicy: PasswordPolicy) {}
    }

    export class Delete {
        static readonly type = 'PasswordPolicyActions.Delete';

        constructor(public policyId: number) {}
    }

    export class Update {
        static readonly type = 'PasswordPolicyActions.Update';

        constructor(public readonly passwordPolicy: PasswordPolicy) {}
    }

    export class FormFailure {
        static readonly type = 'PasswordPolicyActions.FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {}
    }

    export class GetPasswordPolicy {
        static readonly type = 'PasswordPolicyActions.GetPasswordPolicy';

        constructor(public token: string) {
        }
    }

    export class FieldList {
        static readonly type = 'PasswordPolicyActions.FieldList';
    }
}

